// @flow
import CreateServiceNoShowCorrectionModalContainer from './CreateServiceNoShowCorrectionModalContainer';

export default CreateServiceNoShowCorrectionModalContainer;
